export const LABELS = {
  issueBodyHeader: 'Description',
  issueBodyPlaceholder: 'Type your description here…',
  noDescriptionProvided: 'No description provided.',
}
